import { Box } from '@mui/material';
import * as React from 'react';
import { Outlet } from 'react-router-dom';

export interface ILayoutMainProps {
}

export default function LayoutMain(props: ILayoutMainProps) {
  return (
    <Box>
      <Outlet />
    </Box>
  );
}
